module.exports = __webpack_public_path__ + "img/add-toggle.d2c9852f.svg";